import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKaiSecondary = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 330 331",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_95_1501)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 330,
					height: 330,
					rx: 165,
					transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 330 0.460938)",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					opacity: .4,
					cx: 164.897,
					cy: 165.354,
					rx: 165.014,
					ry: 165.015,
					transform: "rotate(-112.273 164.897 165.354)",
					fill: "var(--kai-6-color)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					opacity: .6,
					cx: 164.895,
					cy: 165.355,
					rx: 144.906,
					ry: 144.906,
					transform: "rotate(-112.273 164.895 165.355)",
					fill: "var(--kai-6-color)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 165,
					cy: 165.461,
					rx: 124.419,
					ry: 124.419,
					fill: "var(--kai-6-color)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M109.81 94.6648C82.0428 94.6648 54.618 115.905 54.6178 150.79C54.6178 204.446 91.8216 249.424 141.377 260.453C147.832 256.511 158.618 248.346 153.708 244.89C158.063 246.913 166.588 252.917 165.841 260.757C167.319 258.657 169.995 254.223 168.875 253.29C167.722 252.329 178.133 257.23 177.001 262.38C232.247 256.28 275.384 208.567 275.384 150.79C275.384 115.78 247.93 94.6649 220.193 94.6648C196.491 94.6648 176.297 109.426 167.724 130.367C166.725 132.793 163.278 132.793 162.285 130.367C153.706 109.426 133.512 94.6649 109.81 94.6648ZM165.417 171.025C174.924 171.025 182.633 177.854 182.633 186.28C182.633 197.94 172.575 210.403 167.835 215.631C166.419 217.192 164.414 217.192 162.999 215.631C158.258 210.403 148.2 197.94 148.2 186.28C148.2 177.854 155.91 171.025 165.417 171.025ZM112.707 131.759C113.949 131.759 114.957 132.765 114.957 134.008L114.957 170.539C114.957 171.781 113.95 172.789 112.708 172.789L96.9069 172.789C95.6646 172.789 94.657 171.781 94.6569 170.539L94.6569 134.008C94.657 132.765 95.6646 131.759 96.9069 131.759L112.707 131.759ZM234.105 131.771C235.736 131.767 236.595 133.703 235.496 134.909L220.794 151.036C220.135 151.758 220.142 152.866 220.809 153.58L235.772 169.586C236.89 170.782 236.045 172.736 234.408 172.741L219.669 172.786C219.148 172.787 218.648 172.572 218.293 172.191L200.952 153.64C200.285 152.926 200.277 151.819 200.935 151.096L217.956 132.428C218.31 132.04 218.81 131.818 219.336 131.816L234.105 131.771Z",
					fill: "#E7DAEA"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_95_1501",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 330,
				height: 330,
				rx: 165,
				transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 330 0.460938)",
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgKaiSecondary);
export { ForwardRef as ReactComponent };
